module.exports = __webpack_public_path__ + "img/cn-stu-2-t.8e458765.png";